import Button, { Button as ButtonBase } from '@material/react-button';
import './Button.scss';

/**
 * Component is described here.
 *
 * @version ./package.json
 */
export default Button;

export {
  Button,
  ButtonBase,
};
